import {Box} from '@chakra-ui/react'

const MainLayout = ({children}) => (
    <Box width="100%" minH="100vh" bg="white.100">
        {children}
    </Box>
)

export default MainLayout
